import { useSelector, useDispatch } from 'react-redux';
import {
  setCurrentStep,
  setDeviceCheckFailed,
  setIsReturningUser,
  setShortUrl,
  setCurrentFormId,
  setCurrentFormVersion,
  resetCheckInState,
  selectCurrentStep,
  selectDeviceCheckFailed,
  selectIsReturningUser,
  selectShortUrl,
  selectCurrentFormId,
  selectCurrentFormVersion
} from '../slices/checkInSlice';

/**
 * Custom hook for managing check-in flow state in Redux
 * @returns {Object} Object containing check-in state and update functions
 */
const useCheckIn = () => {
  const dispatch = useDispatch();
  
  // Get state from Redux
  const currentStep = useSelector(selectCurrentStep);
  const deviceCheckFailed = useSelector(selectDeviceCheckFailed);
  const isReturningUser = useSelector(selectIsReturningUser);
  const shortUrl = useSelector(selectShortUrl);
  const currentFormId = useSelector(selectCurrentFormId);
  const currentFormVersion = useSelector(selectCurrentFormVersion);
  
  // Update functions
  const updateCurrentStep = (step) => {
    dispatch(setCurrentStep(step));
  };
  
  const updateDeviceCheckFailed = (failed) => {
    dispatch(setDeviceCheckFailed(failed));
  };
  
  const updateIsReturningUser = (isReturning) => {
    dispatch(setIsReturningUser(isReturning));
  };
  
  const updateShortUrl = (url) => {
    dispatch(setShortUrl(url));
  };
  
  const updateCurrentFormId = (formId) => {
    dispatch(setCurrentFormId(formId));
  };
  
  const updateCurrentFormVersion = (version) => {
    dispatch(setCurrentFormVersion(version));
  };
  
  const resetCheckIn = () => {
    dispatch(resetCheckInState());
  };
  
  return {
    // State
    currentStep,
    deviceCheckFailed,
    isReturningUser,
    shortUrl,
    currentFormId,
    currentFormVersion,
    
    // Update functions
    updateCurrentStep,
    updateDeviceCheckFailed,
    updateIsReturningUser,
    updateShortUrl,
    updateCurrentFormId,
    updateCurrentFormVersion,
    resetCheckIn
  };
};

export default useCheckIn;
